import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {key:'categoryName', label: '分类名称'},
    {key:'manageOrgName', label: '管理部门'},
    {key:'questionOrgName', label: '问题部门'},
    {key:'name', label: '问题描述'},
    {key:'studentLeaderName', label: '反馈人/学信员'},
    {key:'replyResult', label: '评价', render:(value) => {
        return value
    }},

    {key:'status', label: '状态', render:(value) => {
        return value
    }},

    {key:'createDate', label: '创建时间'},
    {key:'termName', label: '所属学期/学年'},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {key:'categoryName', label: '分类名称'},
    {key:'manageOrgName', label: '管理部门'},
    {key:'questionOrgName', label: '问题部门'},
    {key:'name', label: '问题描述'},
    {key:'studentLeaderName', label: '反馈人/学信员'},
    {key:'replyResult', label: '评价', render:(value) => {
        return value
    }},

    {key:'status', label: '状态', render:(value) => {
        return value
    }},

    {key:'createDate', label: '创建时间'},
    {key:'termName', label: '所属学期/学年'},
])


/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('question/get/'+ id, {})
    .then(response => response.payload.data);
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('question/query?'+ params.join('&'), Object.assign({
        type: "course"
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams && extParams.options.length > 0) {
            for(let i = 0; i < columnsArray.length; i++) {
                if(i === 5) {
                    extParams.options.forEach(o => {
                        newArray.push({
                            key: o.name,
                            label: o.value
                        })
                    })
                }
                newArray.push(columnsArray[i])
            }
        }
        return {
            data: response.payload.data,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('question/delete', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.refresh();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const accept = (ids) => {
    return fetch.post('question/accept', ids)
    .then(res => {
        if (res.code === 200) {
            return res;
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'question'+ url;
};

export default {
    querySearch,
    querySearchById,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    getSelection,
    accept
}
